// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614] {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 50px;\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614] {\n  color: rgba(0, 0, 0, 0.85);\n  cursor: text;\n}\n.app-breadcrumb.el-breadcrumb .bigSize[data-v-b50ef614] {\n  position: absolute;\n  left: 20px;\n  top: 41px;\n  font-size: 20px;\n  color: rgba(0, 0, 0, 0.85);\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
